let count = document.querySelector('.jit-custom-blog-article').childElementCount;
let blogCard = document.querySelectorAll('.jit-blog-article-card-div');
blogCard.forEach((x)=>{
  let index = x.classList[3];
  if (Number(index)>=4 && screen.width<768) {
    x.style.marginBottom = 0;
  }
  if(Number(index)>4 && screen.width<768) { 
    x.style.display = "none";
  }
})

const view_all = document.querySelector('.view-all-blogs');
if(view_all){
  view_all.addEventListener(('click'), ()=>{
    blogCard.forEach((x)=>{
    let index = x.classList[3];
    if(Number(index)>4 && screen.width<768) {
      document.querySelector('.view-all-blogs').style.display = "none";
      x.previousElementSibling.style.marginBottom = "54px";
      x.style.display = "block";
    }
  })
  })
}